import { below } from '@voll-intelligence/ui-kit/breakpoints';

/**
 * O degrau do palco ESTREITO das superfícies determinísticas: abaixo dele a
 * barra de busca vira pílula-resumo + folha, a página de resultados e o mapa
 * cheio trocam a faixa de mapa e o voltar pelo botão flutuante Lista↔Mapa. É a
 * régua `sm` do DS (640, `breakpoints.ts` do ui-kit) — o degrau de COMPONENTE,
 * que cobre os dois palcos estreitos reais: o WebView do celular (360–390) e o
 * iframe do host web no desktop (480). Abaixo, exclusivo: em 640 o palco já é
 * largo, como o `sm:` do Tailwind.
 *
 * Um dono só, por produto: as superfícies de um mesmo produto têm de virar na
 * MESMA largura, senão há uma faixa em que o resultado esconde a barra achando
 * que ela é pílula enquanto ela ainda é a fileira larga.
 */
export const NARROW_STAGE_QUERY = below('sm');
